import { MissingProfileData, MissingProfileUpdate } from "shared/interfaces/missingData";
import BooleanResponseWithErrors from "shared/models/booleanResponseWithErrors";
import { httpGet, httpPost, httpPut } from "shared/api/apiHandler";
import urls from "shared/api/spaceStone/urls";
import { InviteProfileData } from "shared/interfaces/signUpViaInvite";

export const startSignUp = async (email: string): Promise<BooleanResponseWithErrors> => {
    const data = { email };
    const result = await httpPost<BooleanResponseWithErrors>(
        window.APP_SETTINGS.spaceStoneApiBaseUri,
        urls.ACCOUNT.REGISTER,
        data
    );

    return result.data;
};

export const resendSignUpLink = async (email: string): Promise<BooleanResponseWithErrors> => {
    const data = { email };
    const result = await httpPost<BooleanResponseWithErrors>(
        window.APP_SETTINGS.spaceStoneApiBaseUri,
        urls.ACCOUNT.RESEND,
        data
    );

    return result.data;
};

export const resendRegistrationExpiredLink = async (token: string): Promise<BooleanResponseWithErrors> => {
    const data = { token };
    const result = await httpPost<BooleanResponseWithErrors>(
        window.APP_SETTINGS.spaceStoneApiBaseUri,
        urls.ACCOUNT.RESEND_REG_EXPIRED_LINK,
        data
    );

    return result.data;
};

export const sendChangeEmailRequest = async ({
    newEmail,
    userId,
}: {
    newEmail: string;
    userId: number;
}): Promise<BooleanResponseWithErrors> => {
    const data = { newEmail, userId };
    const result = await httpPost<BooleanResponseWithErrors>(
        window.APP_SETTINGS.spaceStoneApiBaseUri,
        urls.ACCOUNT.CHANGE_EMAIL_REQUEST,
        data
    );

    return result.data;
};

export const confirmChangeEmailRequest = async (token: string): Promise<string> => {
    const data = { token };

    const result = await httpPost<string>(
        window.APP_SETTINGS.spaceStoneApiBaseUri,
        urls.ACCOUNT.CONFIRM_CHANGE_EMAIL_REQUEST,
        data
    );

    return result.data;
};

export const changeAccountPhone = async (phone: string): Promise<BooleanResponseWithErrors> => {
    const data = { NewPhone: phone };
    const result = await httpPost<BooleanResponseWithErrors>(
        window.APP_SETTINGS.spaceStoneApiBaseUri,
        urls.ACCOUNT.CHANGE_PHONE_REQUEST,
        data
    );

    return result.data;
};

export const startAuthoriseInvitation = async (invitationToken: string): Promise<InviteProfileData> => {
    const data = { invitationToken };

    const result = await httpPost<InviteProfileData>(
        window.APP_SETTINGS.spaceStoneApiBaseUri,
        urls.ACCOUNT.AUTHORISE_INVITATION,
        data
    );

    return result.data;
};

export const getMissingDetails = async (): Promise<MissingProfileData> => {
    const result = await httpGet<MissingProfileData>(
        window.APP_SETTINGS.spaceStoneApiBaseUri,
        urls.ACCOUNT.MISSING_DETAILS
    );

    return result.data;
};

export const updateMissingDetails = async ({ company, user }: MissingProfileUpdate): Promise<MissingProfileUpdate> => {
    const data = { company, user };
    const result = await httpPut<MissingProfileUpdate>(
        window.APP_SETTINGS.spaceStoneApiBaseUri,
        urls.ACCOUNT.MISSING_DETAILS,
        data
    );

    return result.data;
};
